import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputModifyAddSupplierDemandAssign } from './InputModifyAddSupplierDemandAssign.entity';

export class InputModifySupplierDemandAssign<T extends EMode = EMode.entity> {
  /** Alias: add */
  add?: InputModifyAddSupplierDemandAssign<T>[];
  /** Alias: remove */
  remove?: number[];

  __typename?: string;
}

const fields: FieldDefinitions<InputModifySupplierDemandAssign> = {
  add: {
    alias: 'add',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputModifySupplierDemandAssignEntityDefinition: EntitiyDefinition<InputModifySupplierDemandAssign> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputModifySupplierDemandAssign',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
